import { Component, Input } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { BaseTechnicalSectionComponent } from 'src/app/+grid-application-shared/components/common/base-technical-section.component';
import { CommissioningOfEnergyProducer } from 'src/app/+regep/entities/commissioning-of-energy-producer';
import { RegistrationOfEnergyProducerApplicationDocumentTypes } from 'src/app/+regep/entities/enums/regepDocumentTypes';
import { RegistrationOfEnergyProducerTechnicalData } from 'src/app/+regep/entities/regep-technical-data';
import { FormatterData } from 'src/app/constants/app.constants';
import { Document } from 'src/app/jurisdiction/jurisdiction.domain';

@Component({
  selector: 'app-commissioning-of-energy-producer',
  templateUrl: './commissioning-of-energy-producer.component.html',
  styleUrls: ['./commissioning-of-energy-producer.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class CommissioningOfEnergyProducerComponent extends BaseTechnicalSectionComponent {
  @Input() technicalData: RegistrationOfEnergyProducerTechnicalData;

  public readonly dateFormat = FormatterData.date;
  public readonly minDate = new Date();

  public readonly registrationOfEnergyProducerApplicationDocumentTypes = RegistrationOfEnergyProducerApplicationDocumentTypes;

  get model(): CommissioningOfEnergyProducer {
    return this.technicalData.commissioning_of_energy_producer;
  }

  commissioningDateUnknownChange(commissioningDateUnknown: boolean) {
    if (commissioningDateUnknown) {
      this.model.commissioning_date = null;
      this.model.photo_documentation_of_installed_generators_and_converters = null;
      this.model.request_for_meter_mounting = null;
      this.model.confirm_commissioning_corresponds_to_technical_data = null;
    } else {
      this.model.photo_documentation_of_installed_generators_and_converters = new Document(
        RegistrationOfEnergyProducerApplicationDocumentTypes.PhotoDocumentationOfInstalledGeneratorsAndConverters
      );
      this.model.request_for_meter_mounting = new Document(RegistrationOfEnergyProducerApplicationDocumentTypes.RequestForMeterMounting);
    }
  }

  protected get sectionComment(): string | null {
    return this.technicalData.technical_specifications_sections_state?.commissioning_of_energy_producer_comment;
  }

  protected set sectionComment(value: string | null) {
    this.technicalData.technical_specifications_sections_state.commissioning_of_energy_producer_comment = value;
  }

  protected get sectionLocked(): boolean | null {
    return this.technicalData.technical_specifications_sections_state?.is_commissioning_of_energy_producer_locked;
  }

  protected set sectionLocked(value: boolean | null) {
    this.technicalData.technical_specifications_sections_state.is_commissioning_of_energy_producer_locked = value;
  }
}
